import { Controller } from '@hotwired/stimulus';

// Hamburger behaviour for the mobile company navbar: toggles the
// full-screen menu overlay, locking body scroll while it is open.
export default class extends Controller {
  static targets = ['overlay', 'toggle'];

  connect() {
    this.handleKeydown = this.handleKeydown.bind(this);
    // The kit IconButton doesn't render aria-expanded; own it from here.
    this.toggleTarget.setAttribute('aria-expanded', 'false');
  }

  disconnect() {
    this.close();
  }

  open() {
    this.overlayTarget.hidden = false;
    this.toggleTarget.setAttribute('aria-expanded', 'true');
    document.body.style.overflow = 'hidden';
    this.scrollLocked = true;
    document.addEventListener('keydown', this.handleKeydown);
  }

  close() {
    if (!this.hasOverlayTarget || this.overlayTarget.hidden) return;

    this.overlayTarget.hidden = true;
    this.toggleTarget.setAttribute('aria-expanded', 'false');
    document.removeEventListener('keydown', this.handleKeydown);
    if (this.scrollLocked) {
      document.body.style.overflow = '';
      this.scrollLocked = false;
    }
  }

  handleKeydown(event) {
    if (event.key !== 'Escape') return;
    this.close();
    this.toggleTarget.focus();
  }
}
